import { useEffect, useState } from 'react';
import { analyticsService } from '../services/analyticsService';
import { formatPeriodChange, previousPeriod } from '../utils/previousPeriod';

export default function usePreviousComparison(querySpec, orgId, currentValue) {
  const [comparison, setComparison] = useState(null);
  const specKey = JSON.stringify(querySpec || null);

  useEffect(() => {
    const spec = specKey ? JSON.parse(specKey) : null;
    const window = previousPeriod(spec?.date_range);
    if (!spec || !window || currentValue == null || currentValue === '') {
      setComparison(null);
      return undefined;
    }
    let cancelled = false;
    analyticsService.runQuery({
      ...spec,
      date_range: { start: window.prevStart, end: window.prevEnd },
    }, orgId).then((res) => {
      if (cancelled) return;
      if (!res?.ok) {
        setComparison(null);
        return;
      }
      setComparison(formatPeriodChange(currentValue, res.data?.result?.value, window.dayCount));
    }).catch(() => {
      if (!cancelled) setComparison(null);
    });
    return () => {
      cancelled = true;
    };
  }, [currentValue, orgId, specKey]);

  return comparison;
}
